import React, { useState, useEffect } from 'react';
import { Gauge, CheckCircle2, AlertCircle, Search } from 'lucide-react';
import { firmsApi } from '../../api/client';

export const SeoScoreCard = ({ slug }) => {
  const [quality, setQuality] = useState(null);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    firmsApi.get(slug).then(f => setQuality(f.seoQuality)).catch(() => {});
  }, [slug]);

  if (!quality) return null;

  const missing = quality.items.filter(i => i.earned < i.max);
  const color = quality.score >= quality.threshold ? 'text-emerald-600' : quality.score >= 50 ? 'text-amber-600' : 'text-red-600';
  const bar = quality.score >= quality.threshold ? 'bg-emerald-500' : quality.score >= 50 ? 'bg-amber-500' : 'bg-red-500';

  return (
    <div className="bg-white border border-[#cbd8dc] rounded-[10px] p-5 mb-4" data-testid="seo-score-card">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <div className="w-11 h-11 rounded-[7px] bg-[#153e44] flex items-center justify-center"><Gauge className="w-5 h-5 text-[#075a6d]" /></div>
          <div>
            <div className="font-semibold text-[#153e44] text-sm">Qualidade SEO do perfil</div>
            <div className="text-xs text-[#52676e] flex items-center gap-1">
              {quality.indexable
                ? (<><CheckCircle2 className="w-3.5 h-3.5 text-emerald-600" /> Indexado no Google e presente no sitemap</>)
                : (<><AlertCircle className="w-3.5 h-3.5 text-amber-600" /> Abaixo de {quality.threshold} pts: fora do sitemap e com noindex até melhorar</>)}
            </div>
          </div>
        </div>
        <div className="text-right">
          <span className={`text-2xl font-semibold ${color}`} data-testid="seo-score-value">{quality.score}</span>
          <span className="text-xs text-[#6b858e]">/100</span>
        </div>
      </div>
      <div className="mt-3 h-2 bg-[#f2f6f7] rounded-full overflow-hidden">
        <div className={`h-full ${bar} transition-all`} style={{ width: `${quality.score}%` }} />
      </div>
      {missing.length > 0 && (
        <div className="mt-3">
          <button onClick={() => setExpanded(e => !e)} className="text-xs font-semibold text-[#153e44] hover:text-[#063f4c] flex items-center gap-1" data-testid="seo-score-toggle">
            <Search className="w-3 h-3" /> {expanded ? 'Ocultar' : 'Ver'} como ganhar +{missing.reduce((s, i) => s + (i.max - i.earned), 0)} pontos ({missing.length} itens)
          </button>
          {expanded && (
            <ul className="mt-2 space-y-1.5" data-testid="seo-score-tips">
              {missing.map(i => (
                <li key={i.key} className="text-xs text-[#425a62] flex items-start gap-2 bg-[#f7fafb] rounded-[7px] px-3 py-2">
                  <span className="font-semibold text-[#075a6d] shrink-0">+{i.max - i.earned} pts</span>
                  <span><strong>{i.label}:</strong> {i.tip}</span>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </div>
  );
};
